import React, { useEffect, useState } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, LinearProgress, Tooltip } from "@mui/material";
import { Formik, Form } from 'formik'
import * as Yup from 'yup'

import { Add, Edit } from '@mui/icons-material';

import FormikControl from '../../../../../components/FormikControl/FormikControl';
import transactionCategoryServices from '../transactionCategoryServices';
import { useAlert } from '../../../../../context/AlertContext';
import { useAppData } from '../../../../../context/AppDataContext';


function TransactionCategoryForm({data,callBack }) {

    const {AppAlert} = useAlert();
    
    const [formValues, setFormValues] = useState(null);
    const [dialogStatus, setDialogStatus] = useState(false);
    const [savingInProgress, setSavingStatus] = useState(false);

    const initialValues = {
        head:"",
        title:"",
        orgName:"",
        
        
        
    }

    const updateData = ()=>{
        let autoFill = {
            id:data.id,
            head:data.head,
            title:data.title,
        }
        setFormValues(autoFill);
        setDialogStatus(true)
    }

    const validationRule = Yup.object({
        head:Yup.string().required("Required"),
        title:Yup.string().required("Required"),        
    });

    const addNew = ()=>{
        setFormValues(initialValues);
        setDialogStatus(true)
    }

    const handleClose  = () =>{
        setDialogStatus(false);
    }

    const onSubmit = (values, onSubmitProps) => {
        transactionCategoryServices.save(values).then(res=>{
            AppAlert(res.msg);
            setDialogStatus(false);
            callBack();
        }).catch(error=>{
            AppAlert(error.msg,"error");
        }).finally(()=>{
            setSavingStatus(false);
        })
    }

    return (
        <>
            {!data &&
                <Tooltip title="Add New">
                    <button type="button" className="btn btn-primary" onClick={addNew} ><Add/> Add New Transaction Category</button>
                </Tooltip>
            }
            {data &&
                <Tooltip title="Update">
                    <IconButton onClick={updateData} style={{padding:"0px"}}>
                        <Edit/>
                    </IconButton>
                </Tooltip>
            }
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={handleClose}
                fullWidth={true}
                maxWidth="md"
                aria-describedby="alert-dialog-slide-description"
            >

                <Formik
                    initialValues={formValues || initialValues}
                    validationSchema={validationRule}
                    onSubmit={onSubmit}
                    enableReinitialize validateOnMount
                >
                    {
                        (formik) => {
                            //console.log(formik.values);
                            return (
                                <Form>
                                    <DialogTitle>{"Transection Category"}</DialogTitle>
                                    <DialogContent>
                                            <div className="row p-2">
                                                <div className="col-md-6 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text"
                                                        label="Head" name="head"   
                                                    />
                                                </div>

                                                <div className="col-md-6 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text" 
                                                        label="Title" name="title" 
                                                        
                                                    />
                                                </div>
                                                
                                            </div>
                                           
                                        <div className="row mt-3">
                                            <div className='col-md-12'>
                                                {savingInProgress ?
                                                    <LinearProgress/>
                                                    :
                                                    <>
                                                        <button className="btn btn-primary float-end" type="submit" disabled={!formik.isValid} >Save</button>
                                                        <button className="btn btn-outline-primary" type="button" onClick={handleClose}>Cancel</button>
                                                    </>
                                                }
                                            </div>
                                            <div className='col-md-12'>
                                                { /* JSON.stringify(formik.values)  */}
                                            </div>
                                        </div>
                                    </DialogContent>
                                </Form>
                            )
                        }
                    }
                </Formik>
            </Dialog>

        </>
    )
}

export default TransactionCategoryForm